﻿import { payment_response } from "./response";
import { payment } from "../payment_gateway/payment";

export class resp {
    public ttc: payment = new payment();
    public response_payment: payment_response = new payment_response();
}